import angular from 'angular';
import { postClassificationBarComponent } from './postClassificationBarComponent';
import 'components/sharpr/onOutsideClick/onOutsideClickDirective';

angular
	.module('sh.postClassificationBar', ['sh.onOutsideClick'])
	.component('shPostClassificationBar', postClassificationBarComponent());
